<template>
    <form @change="() => {}" @submit.prevent="() => {}" class="form-container flex-1" data-cy="form-container">
        <div class="form-section flex flex-col h-full">
            <div
                class="text-3xl mb-2 pb-2 font-light flex items-end justify-between ml-4 borderline"
                data-cy="policy-information-form-header"
            >
                <div>
                    {{ $t('covers.forms.title.policy_info') }}
                </div>
                <div class="text-default-blue-green">
                    {{
                        $t('covers.forms.title.step', {
                            step_num: 1,
                        })
                    }}
                </div>
            </div>
            <div class="ml-4 flex-1">
                <div class="mb-2" data-cy="policy-information-sub-title">{{ $t('covers.forms.renew.subtitle') }}</div>
                <div class="mb-2">
                    <a-button @click="selectPolicy" class="px-9" type="primary" data-cy="select-policy-btn">
                        {{ $t('covers.forms.renew.buttons.select_policy') }}
                    </a-button>
                </div>
                <div class="flex">
                    <div class="mb-2" data-cy="cover-policy-number-field">
                        <ui-label>{{ $t('covers.forms.renew.policy_no') }}</ui-label>
                        <ui-input v-model="v$.data.policy_number.$model" class="w-auto" />
                    </div>
                    <div class="mb-2 ml-3" data-cy="cover-registration-number-field">
                        <ui-label>{{ $t('covers.forms.renew.registration_no') }}</ui-label>
                        <ui-input v-model="v$.data.registration_number.$model" class="w-auto" />
                    </div>
                </div>
            </div>
            <div class="flex py-2 justify-end">
                <a-button @click="onCancel" class="mr-2" data-cy="policy-cancel-btn">
                    {{ $t('covers.forms.renew.buttons.cancel') }}
                </a-button>
                <a-button @click="onSubmit" class="mr-2" type="primary" data-cy="policy-submit-btn">
                    {{ $t('covers.forms.renew.buttons.submit') }}
                </a-button>
            </div>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';

import { useVuelidate } from '@vuelidate/core';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiLabel,
    },
    props: {
        data: {
            type: Object,
            default: {
                policy_number: '',
                registration_number: '',
            },
        },
    },
    validations: {
        data: {
            policy_number: {},
            registration_number: {},
        },
    },
    methods: {
        selectPolicy() {
            this.$emit('select_policy');
        },
        onCancel() {
            this.$emit('cancel');
        },
        onSubmit() {
            if (this.data.policy_number == '' && this.data.registration_number == '') {
                this.$notification.error({
                    message: this.$t('covers.notifications.error.policy_or_registration_number_required'),
                });
            } else {
                this.$emit('formSubmit');
            }
        },
    },
};
</script>
